var _linearGradient, _linearGradient2, _linearGradient3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmojiSatisfied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    x2: 32,
    y1: 1.304,
    y2: 63.304
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f98900"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    gradientUnits: "userSpaceOnUse",
    x1: 43,
    x2: 43,
    y1: 29.725,
    y2: 20.193
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#414d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#3a4545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522,
    stopColor: "#272e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.914,
    stopColor: "#080909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 21,
    x2: 21,
    xlinkHref: "#linear-gradient-2",
    y1: 29.856,
    y2: 20.875
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_06-Slightly_Smiling_Face",
    "data-name": "06-Slightly Smiling Face"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m32 63c-27.7 0-31.038-24-31-30v-2c-.038-6 3.3-30 31-30 27.7 0 31.038 24 31 30v2c.038 6-3.3 30-31 30z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 43,
    cy: 25,
    fill: "url(#linear-gradient-2)",
    rx: 3,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 25,
    fill: "url(#linear-gradient-3)",
    rx: 3,
    ry: 5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#1d1d1b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.9 12.6c-.5-.667-1.034-1.315-1.59-1.926l1.478-1.347c.6.659 1.176 1.357 1.713 2.074z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.318 53.636c-7.187-8.727-7.326-19.449-7.318-20.642v-1.994c-.033-4.954 1.83-15.28 9.022-22.521 5.589-5.626 13.32-8.479 22.978-8.479 8.913 0 16.2 2.439 21.671 7.249l-1.32 1.5c-5.092-4.478-11.939-6.749-20.351-6.749-9.1 0-16.359 2.654-21.559 7.889-6.729 6.774-8.472 16.453-8.441 21.104v2.007a32.612 32.612 0 0 0 6.861 19.364z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 64c-9.5 0-17.132-2.76-22.7-8.2l1.4-1.43c5.18 5.062 12.346 7.63 21.3 7.63 9.1 0 16.359-2.654 21.559-7.889 6.729-6.774 8.472-16.453 8.441-21.1v-2.121a33.509 33.509 0 0 0 -4.789-16.362l1.7-1.056a35.483 35.483 0 0 1 5.089 17.418v2.11c.033 4.954-1.83 15.28-9.022 22.521-5.589 5.626-13.32 8.479-22.978 8.479z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 31c-2.243 0-4-2.636-4-6s1.757-6 4-6 4 2.636 4 6-1.757 6-4 6zm0-10c-.944 0-2 1.71-2 4s1.056 4 2 4 2-1.71 2-4-1.056-4-2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 31c-2.243 0-4-2.636-4-6s1.757-6 4-6 4 2.636 4 6-1.757 6-4 6zm0-10c-.944 0-2 1.71-2 4s1.056 4 2 4 2-1.71 2-4-1.056-4-2-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 49.013a16.433 16.433 0 0 1 -7.866-2.013c-4.905-2.672-6.05-6.565-6.1-6.73l1.926-.542c.037.127 1 3.268 5.128 5.515a14.383 14.383 0 0 0 13.818 0c4.13-2.243 5.094-5.387 5.133-5.52l1.924.548c-.047.165-1.192 4.058-6.1 6.73a16.433 16.433 0 0 1 -7.863 2.012z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSatisfied);
export default __webpack_public_path__ + "static/media/emojiSatisfied.a623ea24623a374bb34e3ad84ed5e1e7.svg";
export { ForwardRef as ReactComponent };